module.exports = __webpack_public_path__ + "img/WDBC-Logo-93x79.8737e754.png";